import { Link } from 'react-router-dom'
import type { Product } from '../types'
import { money } from '../api'
import { useBag } from '../store'
import { useState } from 'react'

export function Price({ p, big }: { p: Product; big?: boolean }) {
  const sale = !!p.compare_at_cents
  return (
    <div className="price" style={big ? { fontSize: 18 } : undefined}>
      <span className={sale ? 'sale' : ''}>{money(p.price_cents)}</span>
      {sale && <span className="compare">{money(p.compare_at_cents!)}</span>}
    </div>
  )
}

export function ProductCard({ p }: { p: Product }) {
  const { add } = useBag()
  const [adding, setAdding] = useState(false)
  const quick = async (e: React.MouseEvent) => {
    e.preventDefault()
    setAdding(true)
    try { await add(p.id, p.colors[0]?.name ?? '', p.sizes[Math.floor(p.sizes.length / 2)] ?? '') } finally { setAdding(false) }
  }
  return (
    <Link to={`/product/${p.id}`} className="card" data-testid="product-card" data-sku={p.id}>
      <div className="media">
        <img src={p.images[0]} alt={p.name} loading="lazy" />
        {p.images[1] && <img src={p.images[1]} alt="" className="alt" loading="lazy" />}
        {p.badge && <span className={'badge ' + p.badge}>{p.badge}</span>}
        <button className="btn quick" onClick={quick} disabled={adding}>{adding ? 'Adding…' : 'Quick add'}</button>
      </div>
      <div className="meta">
        <div className="name">{p.name}</div>
        <div className="swatches">{p.colors.map(c => <span key={c.name} className="swatch" style={{ background: c.hex }} title={c.name} />)}</div>
        <Price p={p} />
      </div>
    </Link>
  )
}

export function CardSkeleton() {
  return <div><div className="skel media" /><div className="skel line" style={{ width: '70%' }} /><div className="skel line" style={{ width: '30%' }} /></div>
}
